import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {
  ComponentNameTranslationPipe,
  LevelNameTranslationPipe,
  StorageLevelToCustomerLevelNamePipe,
} from '@twaice-fe/frontend/shared/services';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { DataDisplayModule } from '../data-display/data-display.module';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { ChartInfoItemComponent } from './chart-info-item/chart-info-item.component';
import { ChartInfoComponent } from './chart-info.component';
import { NzSegmentedComponent } from 'ng-zorro-antd/segmented';

@NgModule({
  declarations: [ChartInfoComponent, ChartInfoItemComponent],
  imports: [
    CommonModule,
    DataDisplayModule,
    ProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    NzProgressModule,
    SvgIconModule,
    TooltipModule,
    ComponentNameTranslationPipe,
    StorageLevelToCustomerLevelNamePipe,
    LevelNameTranslationPipe,
    NzSegmentedComponent,
    FormsModule,
  ],
  exports: [ChartInfoComponent, ChartInfoItemComponent],
})
export class ChartInfoModule {}
